import { useSelector } from 'react-redux';

export function useText(path) {
  const translations = useSelector(({ i18n }) => i18n.translations[i18n.locale]);
  try {
    return path.split('.').reduce((o, i) => o[i], translations);
  } catch (e) {
    console.warn(`${path} translation key not found`);
    return path;
  }
}
